import { WithTooltip } from 'metronome-ui/components/WithTooltip'

import IconContainer from './icons/IconContainer'

const SectionSummary = ({ items = [] }) => (
  <div className="bg-blue-secondary/30 mb-8 rounded-md p-2 text-white">
    <div className="bg-blue-secondary/30 grid w-full grid-flow-row justify-stretch rounded-md md:grid-flow-col">
      {items.map(({ title, value, tooltip }) => (
        <div className="p-3 text-center" key={title}>
          <h3 className="text-gray-secondary mb-2">
            {title}
            {tooltip && (
              <WithTooltip
                id="tip-position-tracker"
                overlay={<div className="max-w-[20rem]">{tooltip}</div>}
              >
                <IconContainer
                  className="-mt-1 ml-2 inline"
                  name="exclamationmark"
                />
              </WithTooltip>
            )}
          </h3>
          <div className="text-xl">{value ? value : '-'}</div>
        </div>
      ))}
    </div>
  </div>
)

export default SectionSummary
